<template>
    <div>
        <app-wysiwyg
            label="Überschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.title'"
            textpicker-namespace="socials/title"
            required
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Unterüberschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.subtitle'"
            textpicker-namespace="socials/subtitle"
            required
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-link
            v-if="hasPackageBasic"
            label="Button 1"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link'"
        ></app-link>

        <app-link
            v-if="hasPackageBasic"
            label="Button 2"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link2'"
        ></app-link>

        <app-link
            v-if="hasPackageBasic"
            label="Button 3"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link3'"
        ></app-link>

        <app-list
            :data-source="'deha.user.misc.socials'"
            :data-preset="'Listpresets.socials'"
            :data-name="'data.name'"
            :list-subpage="'Socials'"
            :allow-individual="false"
        ></app-list>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Link from '@/components/assorted/Link.vue';
import List from '@/components/fields/complex/List.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'hasPackageBasic'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R005'),
            help: this.$helpers.uiText('R059'),
            removeText: this.$helpers.uiText('R060'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-text': Text,
        'app-wysiwyg': Wysiwyg,
        'app-link': Link,
        'app-list': List
    }
};
</script>
